import i18n from 'i18next';

import { DictionaryLanguageDto } from '@/api/generated/models/dictionary-language-dto';
const ALLOWED_LANGUAGES: Set<DictionaryLanguageDto> = new Set([
  DictionaryLanguageDto.De,
  DictionaryLanguageDto.En,
  DictionaryLanguageDto.Fr,
]);
const DEFAULT_LANGUAGE = DictionaryLanguageDto.En;

export const getAppLanguage = (): DictionaryLanguageDto => {
  const rawLanguage = i18n.language;
  if (!rawLanguage) {
    return DEFAULT_LANGUAGE;
  }
  const language = rawLanguage.toUpperCase().substring(0, 2) as DictionaryLanguageDto;
  if (ALLOWED_LANGUAGES.has(language)) {
    return language;
  }
  return DEFAULT_LANGUAGE;
};
